import React from "react";
import CMSRender from "aldoo-ra/CMS/cms-render";
import Button from "aldoo-ra/Button";
import Typography from "aldoo-ra/Typography";

const DevicesCard = () => {
  // Temporary Devices mock data
  const devices = [
    { id: 1, name: "LWIN-R90WVLF", type: "Windows PC" },
    { id: 2, name: "LWIN-R90WVLF", type: "Windows PC" },
    { id: 3, name: "LWIN-R90WVLF", type: "Windows PC" },
  ];

  //Will we have such popup message?
  const handleRemove = (id) => {
    alert(`Device ${id} removed`);
  };

  return (
    <CMSRender
      contentType="DevicesCard"
      renderItem={(card) => (
        <div className="w-full max-w-[554px] flex flex-col items-start justify-between bg-paper rounded-[50px] gap-5 md:gap-0 px-[40px] py-[35px] shadow-card_shadow">
          {/* Title */}
          <Typography 
            variant="h3" 
            className="text-text mb-[25px]">
            {card.title}
          </Typography>

          {/* Device List */}
          <div className="w-full">
            <table className="table-auto w-full text-left">
              <thead>
                <tr>
                  <th className="pb-4">
                    <Typography variant="body1_accent"> 
                      {card.device_name_label}
                    </Typography>  
                  </th>
                  <th className="pb-4">
                  <Typography variant="body1_accent"> 
                      {card.device_type_label}
                    </Typography>
                  </th>
                </tr>
              </thead>

              <tbody>
                {devices.map((device) => (
                  <tr key={device.id} className="border-t border-bordered">
                    <td className="py-4">
                      <Typography variant="txt1" className="text-text">
                        {device.name}
                      </Typography>
                    </td>

                    <td className="py-4">
                    <Typography variant="txt1" className="text-text">
                        {device.type}
                      </Typography>
                    </td>

                    <td className="py-4 text-right">
                      <Button
                        variant="error_s"
                        onClick={() => handleRemove(device.id)}
                      >
                        {card.cta[0].label}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    />
  );
};

export default DevicesCard;
